import gql from 'graphql-tag';

export default gql`
  query productSearch(
    $sort: [ProductSort!]!
    $filter: ProductFilter
    $pagination: Pagination!
    $isBoostKamereoProducts: Boolean
    $isBoostSameProductGroups: Boolean
    $aggregationOptions: AggregationOptions
  ) {
    productSearch(
      sort: $sort
      filter: $filter
      pagination: $pagination
      isBoostKamereoProducts: $isBoostKamereoProducts
      isBoostSameProductGroups: $isBoostSameProductGroups
      aggregationOptions: $aggregationOptions
    ) {
      totalResults
      totalPage
      data {
        id
        supplier {
          id
          name
          private
          offMarket
          imageUrl
          location {
            city
            district
            address
          }
        }
        imageUrl
        note
        supplierInternalCode
        origin
        preservation
        vat
        uom
        uomLocal
        price
        originalPrice
        savingAmount
        category {
          name
          parent {
            name
          }
        }
        inStock
        name
        description
        isFavorite
        tags
        allowAddToCart
        private
        allowPurchase
        tagImageVn
        tagImageEn
        baseUnit
        baseUom
        netUom
        netUnit
        netUomPrice
        baseUomPrice
        priceV2 {
          price
          originalPrice
          vat
          vatIncluded
        }
      }
      aggregationsData {
        origins
        brandIds
        categoryIdsAndSubCategoryIds
      }
    }
  }
`;
